import { AbstractEthereumConnector, } from "@renproject/multiwallet-abstract-ethereum-connector";
export class EthereumMEWConnectConnector extends AbstractEthereumConnector {
    constructor(options) {
        super(options);
        this.supportsTestnet = false;
        this.handleUpdate = () => {
            this.getStatus()
                .then((...args) => {
                this.emitter.emitUpdate(...args);
            })
                .catch(async (...args) => this.deactivate(...args));
        };
        this.activate = async () => {
            // No good typings for injected providers exist...
            const provider = await this.getProvider();
            if (!provider) {
                throw Error("Missing Provider");
            }
            if (!this.mewConnectProvider) {
                throw Error("Missing MEWConnect Provider");
            }
            // clear any hanging listeners
            await this.cleanup();
            if (provider.enable) {
                await provider.enable().catch((error) => {
                    // TODO ideally this would be a better check
                    if (error.message === "User closed modal") {
                        this.emitter.emitError(new Error("User rejected request"));
                    }
                    throw error;
                });
            }
            if (this.mewConnectProvider.on) {
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                this.mewConnectProvider.on("disconnected", this.deactivate);
            }
            if (provider.on) {
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                provider.on("close", this.deactivate);
                provider.on("networkChanged", this.handleUpdate);
                provider.on("accountsChanged", this.handleUpdate);
                provider.on("chainChanged", this.handleUpdate);
            }
            return this.getStatus();
        };
        this.getProvider = async () => {
            if (this.provider)
                return this.provider;
            const { Provider } = await import("@myetherwallet/mewconnect-web-client").then((m) => (m && m.default ? m.default : m));
            const mewConnectProvider = new Provider({
                windowClosedError: true,
            });
            this.mewConnectProvider = mewConnectProvider;
            this.provider = mewConnectProvider.makeWeb3Provider(this.chainId, this.rpc[this.chainId], true);
            return this.provider;
        };
        // Get default web3 account
        this.getAccount = async () => {
            const send = (await this.getProvider()).send;
            if (!send)
                throw new Error("missing send");
            const params = {
                jsonrpc: "",
                method: "eth_accounts",
                params: [],
            };
            return new Promise((resolve, reject) => send(params, (err, res) => err || !res || res.error
                ? reject(err || (res === null || res === void 0 ? void 0 : res.error) || "no response")
                : resolve(res.result[0])));
        };
        // Cast current ethereum network to Ren network version or throw
        this.getRenNetwork = async () => {
            if (!this.provider)
                throw new Error("not initialized");
            const send = this.provider.send;
            if (!send)
                throw new Error("missing send");
            const params = {
                jsonrpc: "",
                method: "eth_chainId",
                params: [],
            };
            return this.networkIdMapper(await new Promise((resolve, reject) => send(params, (err, res) => err || !res || res.error
                ? reject(err || (res === null || res === void 0 ? void 0 : res.error) || "no response")
                : resolve(res.result)))
            //   await this.provider.send("eth_chainId", [])
            );
        };
        this.deactivate = async (reason) => {
            await this.cleanup();
            const provider = await this.getProvider();
            if (provider.close) {
                await provider.close();
            }
            this.provider = undefined;
            this.emitter.emitDeactivate(reason);
        };
        this.chainId = options.chainId;
        for (const rpc of Object.values(options.rpc)) {
            if (!rpc.startsWith("ws://") && !rpc.startsWith("wss://")) {
                throw new Error("rpc must be websocket (wss://)");
            }
        }
        this.rpc = options.rpc;
    }
    async cleanup() {
        if (this.mewConnectProvider && this.mewConnectProvider.removeListener) {
            this.mewConnectProvider.removeListener("disconnected", 
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.deactivate);
        }
        const provider = await this.getProvider();
        if (provider.removeListener) {
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            provider.removeListener("close", this.deactivate);
            provider.removeListener("networkChanged", this.handleUpdate);
            provider.removeListener("accountsChanged", this.handleUpdate);
            provider.removeListener("chainChanged", this.handleUpdate);
        }
    }
}
